import { Stack } from '@mui/material';
import { findIndex } from 'lodash';
import { ComponentType, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TEST_DATA } from 'src/constants/base';
import { useAuth } from '../../../hooks';
import { completeAttestation } from '../../../thunks/attestation-thunks';
import { TestQuestions } from '../test-questions';
import { TestQuestionsNav } from '../test-questions-nav';
import { TestTimer } from '../test-timer';
import useStyles from './styles';

interface TestExamProps {
  data: Record<string, any>;
  onFinish?: (res: any) => void;
}

export const TestExam: ComponentType<TestExamProps> = ({ data, onFinish }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { user } = useAuth();

  let testData = localStorage.getItem(TEST_DATA);
  const testDataId = testData ? JSON.parse(testData).id : null;

  if (testData && testDataId !== data.id) {
    localStorage.removeItem(TEST_DATA);
    testData = null;
  }

  const userAnswers = testData ? JSON.parse(testData).userAnswers : [];

  const { timeLeft, questions } = data;
  const total = questions.length;
  //const atLeast = Math.ceil((total / 5) * 4);

  const [scrollTo, setScrollTo] = useState<number>();
  const [selected, setSelected] = useState<Record<string, any>[]>(userAnswers);

  const handleChange = (question: number, userAnswer: number) => {
    const selectedAnswer = { question, userAnswer };
    const oldValueIndex = findIndex(selected, (item) => item.question === question);

    const newValue =
      oldValueIndex >= 0
        ? oldValueIndex === 0
          ? [selectedAnswer, ...selected.slice(1)]
          : [
              ...selected.slice(0, oldValueIndex),
              selectedAnswer,
              ...selected.slice(oldValueIndex + 1),
            ]
        : [...selected, selectedAnswer];

    setSelected(newValue);
    localStorage.setItem(TEST_DATA, JSON.stringify({ id: data.id, userAnswers: newValue }));
  };

  const handleFinish = () => {
    completeAttestation(
      user?.data?.id,
      userAnswers
    )(dispatch).then((res) => {
      if (onFinish) onFinish(res);
      localStorage.removeItem(TEST_DATA);
    });
  };

  return (
    <div className={classes.root}>
      {/*<Typography variant="subtitle2" mb={3} color="primary">*/}
      {/*  Для успешного прохождения аттестации необходимо ответить правильно минимум на {atLeast}{' '}*/}
      {/*  вопроса из {total}*/}
      {/*</Typography>*/}
      <Stack direction="row" spacing={4} className={classes.grid}>
        <TestQuestions {...{ questions, userAnswers, handleChange }} qIndex={scrollTo} />
        <Stack width={288}>
          <TestTimer left={timeLeft} onEnd={handleFinish} />
          <TestQuestionsNav
            questions={questions}
            total={total}
            done={userAnswers?.length || 0}
            selected={selected}
            scrollTo={setScrollTo}
            onFinish={handleFinish}
          />
        </Stack>
      </Stack>
    </div>
  );
};
